import {getMainDataset} from "../helper/mainHelper";

document.addEventListener('DOMContentLoaded', function () {
    const {tchatbotAccessToken, tchatbotLanguageCode, tchatbotPersonality} = getMainDataset();
    initDhlTchatBot(tchatbotPersonality, tchatbotAccessToken, tchatbotLanguageCode);
});

/**
 * Initialise le widget DHL Virtual Assistant (VA Widget)
 *
 * @param {string} tchatbotPersonality - La personnalité du chatbot
 * @param {string} tchatbotAccessToken - Token d'accès
 * @param {string} tchatbotLanguageCode - Code de langue (ex: "fr", "en")
 */
function initDhlTchatBot(tchatbotPersonality, tchatbotAccessToken, tchatbotLanguageCode) {
    if (!tchatbotAccessToken || !tchatbotLanguageCode || !tchatbotPersonality) {
        console.warn('⚠️ Impossible d’initialiser le chatbot DHL : paramètre(s) manquant(s)');
        return;
    }
    if (!window.dhlVAWidget || typeof window.dhlVAWidget.init !== 'function') {
        console.warn('⚠️ DHL VA Widget non chargé ou init indisponible.');
        return;
    }

    window.dhlVAWidget.init({
        id: `${tchatbotPersonality}/${tchatbotAccessToken}`,
        languageCode: tchatbotLanguageCode,
        // Sur cette page, le badge reCAPTCHA occupe déjà le coin bas-droit : on relève le chatbot au-dessus pour éviter le chevauchement
        widgetIconOffsetY: 90
    });
}
